import Platform from "../../../../libs/utility/Platform"
import { Theme } from "../../../components/constants" 

export default {
    loginForm:{
        display: "flex",
        flexDirection: "column",
        padding: "15px",
        width: "100%",
    },
    fieldMarginTop: {
        marginTop: "30px",
    },
    fullNameContainer: {
        display: "flex",
        flexDirection: Platform.isMobileView() ? "column" : "row",
        flexWrap: "wrap",
    },
    nameFieldsDiv: {
        flex: 1,
    },
    marginTopDependentField: {
        marginTop: "15px",
    },
    forgotPasswordDiv:{
        marginTop: "8px",
    },
    submitButtonDiv: {
        width: "100%",
        marginTop: "30px",
    },
    bottomLinkContainer: {
        display: "flex",
        flexDirection: "row",
        marginTop: "10px",
        fontSize: "14px",
    },
    separatorDiv: {
        marginTop: "20px",
    },
    signUpLink: {
        marginLeft: "6px",
    },
    errorMessage: {
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.ERROR_TEXT,
    },
    agreeTermsDiv: {
        display: "flex",
        flexDirection: "row",
        marginTop: "5px",
    },
    agreeTermsLink: {
        color: Theme.PRIMARY,
        textDecoration: "underline",
        marginLeft: "10px",
    },
    marketingCheckboxDiv:{
        marginTop: "5px",
    },
    signUpOptionsContainer:{
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        justifyContent: "center",
        alignItems: "center",
    },
    signWithOptionsMainContainer:{
        marginTop: "30px",
    },
    signInOptionsTitle: {
        fontSize: "14px",
        lineHeight: "18px",
        marginBottom: "10px",
        textAlign: "center",
    },
    appleSignupButton: { width: "40px", height: "40px", border: "1px solid #dadce0", background: "white", padding: "0px" }
}